export default "__VITE_ASSET__vJGYVg6z__"